export const ENTERPRISE_LEVELS_DETAILS = "ENTERPRISE_LEVELS_DETAILS";

const initialState = null;

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ENTERPRISE_LEVELS_DETAILS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "enterpriseLevelsDetails";

const storeMapping = {[storeName]: reducer};

export const enterpriseLevelsDetailsSelector = (state) => state[storeName];

export default storeMapping;


